import { BASE_URL } from '../middleware/api';

function addBaseUrl(url) {
  return `${BASE_URL}${url}`;
}

const entity = (path) => {
  return addBaseUrl(path);
};

export const apiEndpoints = () => {
  return {
    entity
  };
};

// export const GET_ALL_IMAGES = '/assessment_image/pending'
export const GET_ALL_IMAGES = '/assessment_image/reserve_pending';
export const GET_ALL_DOMAINS = '/assessment_domain/reserve_pending';
export const CHECK_KEEP_DOMAINS = '/assessment_domain/keep_reserved';
export const GET_IMAGE_DATA = '/assessment_image/{imageId}';
export const GET_DOWNLOADED_IMAGE_DATA =
  '/assessment_image/{imageId}/downloaded_image';
export const GET_SAME_IMAGES_COUNT_DATA =
  '/assessment_image/{imageId}/same_domain_count';
export const GET_SAME_DOMAIN_COUNT_DATA =
  '/assessment_domain/{domainId}/images_count';
export const GET_DOMAIN_DATA = '/assessment_domain/{domainId}';
export const SAVE_DOMAIN_DATA = '/assessment_domain/{domainId}/update';
export const SAVE_DOMAIN_DATA_AS_REVIEW =
  '/assessment_domain/{id}/update_review';
export const GET_RESERVE_DOMAIN_PENDING = '/assessment_domain/reserve_pending';
export const GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING =
  '/assessment_domain/reserve_pending_review';
export const GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_BY_DOMAIN_NAME =
  '/assessment_domain/reserve_pending_review/{domain}';
export const GET_RESERVE_PENDING_QUALITY_CONTROL =
  '/assessment_domain/reserve_pending_quality_control';
export const GET_RESERVE_PENDING_SOCIAL_MEDIA =
  '/assessment_domain/reserve_pending_social_media';
export const GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_BY_DOMAIN_NAME_TEST =
  '/assessment_domain/reserve_pending_review_domain';
export const GET_DELIVERED_IDS = '/assessment_domain/{id}/delivered_ids';
// export const GET_DOMAINS_IMAGES_STATUSES_IDS = '/assessment_domain/{id}/images_statuses_ids'
export const GET_DOMAINS_IMAGES_STATUSES_IDS =
  '/assessment_domain/{id}/images_by_domain';
export const FILTER_SIGHTINGS =
  '/assessment_domain/{id}/images_by_domain_filter';
export const GET_FIRST_DOMAIN_SIGHTINGS =
  '/assessment_domain/{id}/first_sightings';
export const GET_LAST_DOMAIN_SIGHTINGS =
  '/assessment_domain/{id}/last_sightings';
export const UPDATE_IMAGE_STATUS = '/assessment_image/{id}/update_image';
export const SET_RETURNED_FOR_COMMENT_TRUE =
  '/assessment_domain/{id}/set_returned_for_comment_true';
export const SET_RETURNED_FOR_REVIEW =
  '/assessment_domain/{id}/set_returned_for_review';
export const UPDATE_IMAGES_DATA = '/assessment_image/update_images';
export const UPDATE_HOLD_DOMAIN_DATA = '/assessment_domain_hold/{id}/update';
export const DELETE_HOLD_DOMAIN_DATA = '/assessment_domain_hold/{id}';
export const SAVE_HOLD_IMAGES_DATA = '/assessment_image_hold/multiple_save';
export const SAVE_MULTIPLE_IMAGES_STATUS_DATA =
  '/assessment_image/set_multiple_images_status';
export const SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_DATA =
  '/assessment_image/set_multiple_images_offline_status';
export const GET_LANGUAGES = '/dictionary/language';
export const GET_ALL_USERS = '/assessment_user';
export const CREATE_USER = '/assessment_user';
export const UPDATE_USER = '/assessment_user';
export const RESET_USER_PASSWORD = '/assessment_user/password';
export const GET_USER_BY_ID = '/assessment_user/{id}';
export const GET_USER_QUEUE_BY_ID = '/assessment_user_work_queue';
export const REPLACE_ALL_USER_QUEUE = '/assessment_user_work_queue';
export const USER_QUEUE_COUNT =
  '/assessment_user_work_queue/count_query_results';
export const USER_VALIDATE_QUEUE = '/assessment_user_work_queue/validate_query';
// export const GET_USER_STATISTIC_BY_ID = '/assessment_user_result/{id}'
export const GET_USER_STATISTIC_BY_ID = '/report/user_statistic';
export const GET_LOGGED_USER_STATISTIC = '/report/user_statistic/user';
export const GET_ALL_USERs_STATISTIC = '/report/user_statistic';
// IMAGE TABLE DATA
export const GET_IMAGE_FIELDS_DATA = '/assessment_image/fields';
export const DELETE_DOMAIN_FROM_BLACKLIST = '/blacklisted_domain/{domainId}';
export const BLACKLISTED_DOMAIN_BATCH_URI = '/blacklisted_domain/batch';
export const BULK_CHANGES = '/assessment_image/update_image_batch';
export const REMOVE_FROM_BLACKLIST = '/assessment_domain/re_blacklisted/{id}';

export const SEND_UPDATED_IMAGE_URL = '/assessment_image/update_image_url';

export const GET_XLSX_FILE = '/assessment_domain/report_xlsx_for_images';
export const GET_CSV_FILE = '/assessment_image/report_csv_for_images';
export const SET_UPDATE_IMAGES_FOR_LEGAL =
  '/assessment_image/update_delivered_images';
export const SET_BLACK_LIST = '/assessment_domain/set_blacklisted/';
export const SEND_IMAGES_REPORT = '/assessment_domain/send_report_for_images';
export const APPROVE_DOMAIN =
  '/assessment_domain/{id}/set_pending_final_review';
export const WHO_IS_DATA = '/third_party_domain_data/main/{domain}';

export const GET_NOT_PURSUABLE_FORMAT =
  '/assessment_image/not_pursuable_format/';
export const GET_REGISTERED_ASSET_FORMAT =
  '/registered_asset/registered_asset_format/';
export const GET_BLACKLISTED_DOMAIN = '/blacklisted_domain/batch_format';
export const GET_IMAGES_STATUS_FORMAT =
  '/assessment_image/image_status_format/';
export const GET_AGENCY_FORMAT = '/instruction/import_legitimate_agency/';
export const GET_COUNTRIES_FORMAT = '/instruction/import_countries/';

export const LOAD_NOT_PURSUABLE_BATCH = '/original_image/not_pursuable_batch';
export const LOAD_REGISTERED_ASSET_BATCH = '/original_image/registered_batch';
export const LOAD_BLACKLISTED_DOMAIN_BATCH = '/blacklisted_domain/batch';
export const LOAD_BLACKLISTED_SUBDOMAIN_BATCH =
  '/blacklisted_domain/subdomains/batch';
export const LOAD_STATUSES_BATCH = '/assessment_image/image_status_batch';
export const LOAD_NOT_PURSUABLE_CSV =
  '/original_image/not_pursuable_from_file/';
export const LOAD_REGISTERED_ASSET_CSV = '/original_image/registered_from_file';
export const LOAD_BLACKLISTED_DOMAIN_CSV = '/blacklisted_domain/load_batch_csv';
export const LOAD_BLACKLISTED_SUBDOMAIN_CSV =
  '/blacklisted_domain/subdomains/load_batch_csv';
export const LOAD_STATUSES_CSV = '/assessment_image/load_image_status';
export const LOAD_COUNTRIES_CSV = '/assessment_domain/import_countries';
export const LOAD_LEGITIMATE_AGENCY_CSV =
  '/assessment_domain/import_agency_legitimate';

export const DISCARD_QC = '/assessment_domain/return_for_review';
export const DISCARD_FR = '/assessment_domain/return_for_qc';

// PATH
// export const LOGIN_USER = '/login'
export const LOGIN_USER = '/auth/login';
export const LOGOUT_USER = '/logout';
export const GET_USER_INFO = '/auth/me';

export const GET_LIST_OF_FILES = '/files';
export const GET_FILE_CONTENT = '/files/file';
export const SAVE_FILE_CONTENT = '/files/save';

export const CHAT_DATA = '/conversation';

export const NO_COMMERCIAL_REASONS = '/assessment_domain/no_commercial_fields';

// export const GET_DOMAIN_BY_NAME = '/assessment_domain';

export const GET_BLACKLISTED_DOMAIN_BY_NAME = '/blacklisted_domain';

export const GET_IMAGES_TABLE_AGENCIES = '/assessment_image/agency_list';

export const GET_IMAGES_BY_AGENCY_AND_ID =
  '/assessment_domain/domain_image_info';

export const GET_DOMAINS_BY_USAGE_URL =
  '/assessment_image/by_usage_url_part_without_counting';

export const GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL =
  '/assessment_image/by_usage_url_part_without_counting_clickhouse';

export const GET_DOMAINS_BY_CLICKHOUSE_ARCHIVE_USAGE_URL =
  '/assessment_image/archive/by_usage_url_part_without_counting_clickhouse';

export const GET_USAGE_URL_COUNT = '/assessment_image/get_counting';

export const GET_DOMAIN_BY_NAME = '/assessment_domain/domain_image_info';

export const GET_DOMAIN_FLOW_STATUSES =
  '/assessment_domain/domain_flow_status_list';

export const GET_COUNTRIES_LIST = '/assessment_domain/countries_list';

export const GET_IMAGE_COMMENTS = '/conversation';

export const ADD_MSG_TO_ONE_IMAGE = '/conversation';

export const ADD_MSG_TO_ALL_IMAGES = '/assessment_domain/add_message_to_images';

export const GET_SIGHTINGS_INFO = '/assessment_domain/{id}/images_fields_info';
export const PARK_DOMAIN = '/assessment_domain/park_until';
export const GET_FB_IMAGE_URL =
  '/assessment_image/{assessmen_image_id}/fb_image_url';
